import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as HELPER from "@src/config/helper";
import Pagination from '@src/common/Pagination';
import {MANAGER_LEVEL_IDS} from '../config/constant'
import secureStorage from '../../src/config/encrypt';
import Select from 'react-select';
import { AssignPayment } from '@src/store/slices/reconciliation';

type OptionType = {
  value: number;
  label: string;
};

interface ReconciliationTableProps {
  reconciliationList: any[];
  paginationData: any;
  getReconciliationListing: (params: any) => void;
  selectedFilters: any;
  statusFilterList: any;
  paymentTypeList: any;
  paymentMethodList: any;
  reasonList: any
  assignUsers:any;
  selectedLeads:any;
  setSelectedLeads:(params: any) => void;
  setIsAllLeadsSelected:(params: any) => void;
}

const ReconciliationTable: React.FC<ReconciliationTableProps> = ({
  reconciliationList,
  paginationData,
  getReconciliationListing,
  selectedFilters,
  statusFilterList,
  paymentTypeList,
  paymentMethodList,
  reasonList,
  assignUsers,
  selectedLeads,
  setSelectedLeads,
  setIsAllLeadsSelected
}) => {
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  const authUserInfo = secureStorage.getItem("authUserInfo");
  const [leadListData, setLeadListData] = useState<any>([]);
  const [showSelectedAssignSave, setShowSelectedAssignSave] = useState(0);

  useEffect(() => {
    setLeadListData(reconciliationList);
  }, [reconciliationList])

  const navigate = useNavigate();
  const page = 1;

  const detailPageRedirect = (item: any) => {
     localStorage.setItem(`recon_detail${item.hashId}`, item.reco_status);
      navigate(`/details/reconciliation-detail/${item.hashId}`, {
      state: { item, paymentTypeList, paymentMethodList, reasonList },
    });
  }

  const handleRequestData = (params: any) => {
    let apiParams = {
        ...selectedFilters,
        page_number: params.page_no
    }

    getReconciliationListing(apiParams)
  }

  const handleSort = (column: string) => {
      const newSortDirection = column === 'transaction_date' && sortDirection === 'asc' ? 'desc' : 'asc';
      setSortDirection(newSortDirection);
    
      selectedFilters.sortBy = {label:"transaction_date", value: newSortDirection};
      handleRequestData({ page_no: 1 });
  };

  const getStatusLabelAndClass = (status: number | string, statusList: OptionType[]) => {
    if(status === 0) status = 3
    const statusItem = statusList.find(item => item.value === status);
    let className = '';

    switch (status) {
      case 1:
        className = 'reconciled-txt';
        break;
      case 2:
        className = 'rejected-txt';
        break;
      default:
        className = '';
    }

    return {
      label: statusItem?.label || '',
      className,
    };
  };

  const getPaymentType = (type: number | string, paymentList: OptionType[]) => {
    const label = paymentList.find(item => item.value === type)?.label || '';
    return label;
  }

  const getSelectedAssignUser = (id: any) => {    
    let getSelectedUser = assignUsers.find((u: any) => +u.value === +id);
    return getSelectedUser || null;
  }

  const handleChangeAssign = (leadId: any, e: any) => {
    setLeadListData(reconciliationList.map((u: any) => { return (u.id === leadId) ? { ...u, 'assigned_reco_id': e.value } : u }));
    setShowSelectedAssignSave(leadId);
  }

  const saveAssignLeadHandler = (params: { id: string, action: string }) => {
      if (params.action === "cancel") {
          setShowSelectedAssignSave(0);
          setLeadListData([...reconciliationList])
      } else {
          let getLead: any = leadListData.find((ins: any) => ins.id === params.id) || {};
          AssignPayment({ payment_id: params.id, "assigned_user_id": getLead['assigned_reco_id'],user_type:'assigned_reco_id' }).then((res: any) => {
              if(res && res.status === 200) {
                handleRequestData({page_no: 1});                              
                setShowSelectedAssignSave(0)
              }
          }).catch(err => {
  
          })
      }
    }

      // Handle select all checkbox
    const handleSelectAll = (isChecked: boolean) => {
        if (isChecked) {
            // select all
          const allSelected: any[] = leadListData.map((lead: any) => ({
              id: lead.id
          }));
          setSelectedLeads(allSelected);
      } else {
          // unselect all
          setSelectedLeads([]);
      }
  };
  // Handle individual checkbox change
  const handleItemSelect = (lead: { id: number},isChecked: boolean): void => {
      if (isChecked) {
          setSelectedLeads((prev:any) => [
              ...prev,
              {
                id: lead.id,
              },
          ]);
      } else {
          setSelectedLeads((prev:any) =>
              prev.filter(
                  (item:any) =>
                  !(
                      item.id === lead.id
                  )
              )
          );
      }
  }
  const isAllSelected = leadListData.length > 0 && selectedLeads.length === leadListData.length;
  setIsAllLeadsSelected(isAllSelected);

  return (
    <div className='data-table reconciliation-table-list'>
      <table>
        <thead>
          <tr>
            {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && 
              <th>
                <input
                    type="checkbox"
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    style={{ cursor: 'pointer' }}
                    checked={isAllSelected}
                />
              </th>
            }
            <th style={ !MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) ? { width: 'auto' } : {}}>Policy No.</th>
            <th>Customer Details</th>
            <th>Insurance ID</th>
            <th>QR Code</th>
            <th style={{width:'11%'}}>Transaction Date
                <i className={`ic-sort-${sortDirection}`} style={{ cursor: 'pointer' }} onClick={() => handleSort('transaction_date')}></i>
            </th>
            <th>Amount</th>
            <th>Payment Type</th>
            <th>Payment Proof</th>
            <th>Status</th>
            {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) &&<th style={{width:"10%"}}>Assigned to</th>}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>

            {
              leadListData.length
                  ?
              leadListData.map((list: any, key: number) =>
                <tr key={key}>
                  {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && 
                    <td>
                        <input
                            type="checkbox"
                            onChange={(e) => handleItemSelect({id: list.id}, e.target.checked)}
                            style={{ cursor: 'pointer' }}
                            checked={selectedLeads.some((item:any) => item.id === list.id)}
                        />
                    </td>
                  }
                  <td><span className='truncate' title={list.policy_no}>{list.policy_no || ""} </span> </td>
                  <td>
                    <span className='truncate t-bold' title={list?.customer_name}>{list?.customer_name || ''}</span>
                    <span>{list?.customer_mobile || ''}</span>
                  </td>
                  <td>{list.insurance_id || ""}</td>
                  <td className=''>
                    <div className='d-flex'>
                    <span className='truncate' title={list.transaction_id}>{list.transaction_id || ""}</span>
                    <span>
                      {
                        list.transaction_id
                        &&
                        <i
                          className='ic-content_copy m-sm-l'
                          onClick={() => HELPER.handleCopyText(list.transaction_id)} style={{ cursor: 'pointer' }}>
                        </i>
                      }
                    </span>
                    </div>                
                  </td>
                  {/* <td>{dateFormat(list.transaction_date, 'UTC:dd mmm yyyy')}</td> */}
                  <td style={{width:'11%'}}>{list.transaction_date}</td>
                  <td>{HELPER.addCurrencyFormatting(list.amount) || 0}</td>
                  <td>{getPaymentType(list.payment_type, paymentTypeList)}</td>
                  <td>{list.payment_proof !== "" ? 'Attached' : 'Not Attached'} 
                    {
                      list.payment_proof !== ""
                       &&
                      <a 
                        href={list.payment_proof} 
                       // download
                        target="_blank"  
                        rel="noopener noreferrer"
                        className="download-link" 
                        title="Download Payment Proof"
                        style={{ textDecoration: 'none' }}
                      >
                        <i className='ic-attach_file'></i>
                      </a>
                    }
                    </td>
                  {/* <td><span className='reconciled-txt'>{list.payment_status || ""}</span></td> */}
                  <td>
                    {(() => {
                      const { label, className } = getStatusLabelAndClass(list.reco_status, statusFilterList);
                      return <span className={className}>{label}</span>;
                    })()}
                  </td>
                  {
                  (MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids)) &&
                  <td style={{width:"10%"}}>
                    <div className="select-table">
                      <fieldset className="single-select assigned-to-select reco-assign-user-list reco-assign-user-list">
                        <div className="material table-select-box__placeholder">
                          <Select
                              value={getSelectedAssignUser(list.assigned_reco_id)}
                              options={assignUsers}
                              onChange={(e) => handleChangeAssign(list.id, e)}
                              placeholder="Assign To"
                              styles={{
                                  option: (provided) => ({
                                      ...provided,
                                      whiteSpace: 'normal',
                                      wordWrap: 'break-word',
                                      wordBreak: 'break-word'
                                  })
                              }}
                          />
                          {
                            showSelectedAssignSave === list.id &&
                            <div className="amt-edit-opt"><button className="btn-primary" onClick={() => saveAssignLeadHandler({ id: list.id, action: 'save' })}>Save</button><i className="ic-clearclose" onClick={() => saveAssignLeadHandler({ id: list.id, action: 'cancel' })}></i></div>
                          }
                        </div>
                      </fieldset>
                    </div>
                  </td>
                }
                  <td>
                    <ul className="action-btn">
                      <li className="" title="View Detail" onClick={() => detailPageRedirect(list)}>
                            <i className="ic-remove_red_eyevisibility"></i>
                        </li>
                    </ul>
                  </td>
                </tr>
                )

              :
              <tr><td colSpan={9} style={{ textAlign: 'center' }}>No data found</td></tr>

            }

        </tbody>
      </table>

      {(paginationData && paginationData['total'] > 10) && <Pagination paginateData={{
          page,
          loading: false,
          totalLengthWithoutPagination: paginationData['total'],
          paginationData,
          filteredData: selectedFilters
        }}
        sendRequestDataToParent={handleRequestData} />}

    </div>
  )
}

export default ReconciliationTable;